<div class="header">
  <!-- Header left -->
  <div class="left">
    <!-- Category name -->
    <div class="category">Add Deal</div>
  </div>

  <div class="right"></div>
  <div class="loader" *ngIf="loadingParcel">
    <mat-progress-bar class="table-loading-bar" [mode]="'indeterminate'"></mat-progress-bar>
  </div>
</div>
<div class="flex flex-auto side-panel-container">
  <div class="flex flex-col w-3/4 border-right p-2">
    <div class="viewer-wrapper">
      <div class="viewer-resize">
        <parcel-map
          (onSelectParcelEvent)="onSelectParcel($event)"
          (onSelectLatLngEevnt)="onSelectLatLng($event)"
          (onDeSelectParcelEvent)="onDeSelectParcel($event)"
          [allowClickEvent]="!loadingParcel"
        ></parcel-map>
      </div>
    </div>
  </div>
  <div class="flex flex-col w-1/4 side-panel">
    <div class="form-wrapper">
      <form [formGroup]="addProjectForm">
        <div class="flex flex-col gt-xs:flex-col">
          <mat-form-field class="subject flex-auto">
            <mat-label>Deal Name</mat-label>
            <input matInput placeholder="Enter Deal name" [formControlName]="'title'" data-cy="deal-name" />
          </mat-form-field>
          <mat-form-field class="flex-auto">
            <mat-label>View</mat-label>
            <mat-select [formControlName]="'pipeline_id'" placeholder="--Select--" data-cy="deal-pipeline">
              <mat-option *ngFor="let pipeline of pipelines" [value]="pipeline.id">
                {{ pipeline.name }}
              </mat-option>
            </mat-select>
          </mat-form-field>
          <mat-form-field class="flex-auto">
            <mat-label>Property Type</mat-label>
            <mat-select [formControlName]="'property_type_id'" placeholder="--Select--" data-cy="deal-property-type">
              <mat-option *ngFor="let propertyType of propertyTypes" [value]="propertyType.id">
                {{ propertyType.name }}
              </mat-option>
            </mat-select>
          </mat-form-field>
          <mat-form-field class="flex-auto">
            <mat-label>Deal Layout</mat-label>
            <mat-select [formControlName]="'template_id'" placeholder="--Select--" data-cy="deal-template">
              <mat-option *ngFor="let projectTemplate of projectTemplates" [value]="projectTemplate.id">
                {{ projectTemplate.name }}
              </mat-option>
            </mat-select>
          </mat-form-field>
          <fieldset [formGroupName]="'property'" *ngFor="let property of properties; let i = index; trackBy: trackByFn">
            <fieldset class="form-group" [formGroupName]="'address'">
              <div class="flex flex-col gt-xs:flex-row">
                <mat-form-field class="flex-auto gt-xs:pr-3">
                  <mat-label>Property #{{ i + 1 }}</mat-label>
                  <input
                    matInput
                    google-place
                    placeholder="Address"
                    [value]="property.address.address_string"
                    [disabled]="'true'"
                  />
                </mat-form-field>
              </div>
            </fieldset>
          </fieldset>

          <div class="buttons mt-3 flex flex-wrap justify-end">
            <!-- Send -->
            <button
              class="send-button mb-2"
              mat-flat-button
              [color]="'primary'"
              [disabled]="addProjectForm.pristine || addProjectForm.invalid"
              (click)="save()"
              data-cy="deal-create-button"
            >
              <span *ngIf="!addProjectForm.disabled">Create</span>
              <mat-progress-spinner *ngIf="addProjectForm.disabled" [diameter]="24" [mode]="'indeterminate'">
              </mat-progress-spinner>
            </button>
            <!-- Send & Create New Deal -->
            <button
              class="send-button ml-2 mb-2"
              mat-flat-button
              [color]="'primary'"
              [disabled]="addProjectForm.pristine || addProjectForm.invalid"
              (click)="saveAndCreateNew()"
            >
              <span *ngIf="!addProjectForm.disabled">Create & Add Another</span>
              <mat-progress-spinner *ngIf="addProjectForm.disabled" [diameter]="24" [mode]="'indeterminate'">
              </mat-progress-spinner>
            </button>
            <!-- Discard -->
            <button class="discard-button ml-2 mb-2" mat-button (click)="discard()">
              <span>Cancel</span>
            </button>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>
